<template>
    <div class="comContent page-content">
        <div class="header-box">
            <el-form :inline="true" style="text-align: left">
                <el-row style="margin: 10px  0 10px">
                    <el-form-item prop="activityName">
                        <el-input v-model.trim="formSearch.activityName" style="width: 200px;" placeholder="请输入活动名称" clearable
                            size="small" />
                    </el-form-item>
                    <el-form-item prop="status">
                        <el-select v-model="formSearch.status" clearable style="width: 160px;" size="small"
                            placeholder="请选活动状态">
                            <el-option v-for="item in activeOptions" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="date">
                        <el-date-picker v-model="formSearch.date" size="small" value-format="yyyy-MM-dd" type="daterange"
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item prop="shopName">
                        <el-input v-model.trim="formSearch.shopName" style="width: 200px;" placeholder="请输入店铺名称" clearable
                            size="small" />
                    </el-form-item>
                    <el-form-item prop="goodsInfo">
                        <el-input v-model.trim="formSearch.goodsInfo" style="width: 200px;" placeholder="请输入商品信息" clearable
                            size="small" />
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="search">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" @click="reset">重置</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <myTable :selection="false" :page="page" :operation="false" v-loading="loading" :table-data="tableData"
            :table-option.sync="tableOption" @page-change="getList" :expand="false">
            <template slot="status" slot-scope="scope">
                {{ scope.row.status | filtersStatus }}
            </template>
            <template slot="activeTime" slot-scope="scope">
                {{ scope.row.startTime }}
                -
                {{ scope.row.endTime }}
            </template>
            <template slot="platformActivityGoodsInfoVO" slot-scope="scope">
                <div class="goods-info" v-if="scope.row.platformActivityGoodsInfoVO">
                    <div class="goods-info-image">
                        <el-image :src="scope.row.platformActivityGoodsInfoVO.image || avater" lazy
                            style="width:100%;height: 100%;" />
                    </div>
                    <div class="goods-info-content">
                        <p class="goods-name">
                            {{ scope.row.platformActivityGoodsInfoVO.goodsName }}
                        </p>
                        <p>
                            规格: {{ scope.row.platformActivityGoodsInfoVO.specification || '-' }}
                        </p>
                        <p>
                            生产厂家: {{ scope.row.platformActivityGoodsInfoVO.factory || '-' }}
                        </p>
                        <p>
                            69码: {{ scope.row.platformActivityGoodsInfoVO.barCode || '-' }}
                        </p>
                    </div>
                </div>
            </template>
            <template slot="subsidyType" slot-scope="scope">
                    <div class="subsidy-type-cls">
                        <div>
                            <span>一次性买满{{ scope.row.threshold }}元</span>
                        </div>
                        <div v-if="scope.row.type == 1">
                            <span>{{ scope.row.discount }}折<br /></span>
                        </div>

                        <div v-if="scope.row.type == 2">
                            减固定金额 ￥ {{ scope.row.discount }}<br />
                        </div>
                        <span v-if="scope.row.singleGoodsLimitFlag == '0'"> 单笔订单无上限</span>
                        <span v-if="scope.row.singleGoodsLimitFlag == '1'"> 单笔订单上限{{ scope.row.singleGoodsLimit }}元</span>
                    </div>
                </template>
            <template slot="operation" slot-scope="scope">
                <div style="margin: 0 0px"   v-if="[0,1,3].includes(scope.row.status)" >
                    <el-link type="primary" :underline="false" @click="deletGoods(scope.row)" style="margin-right: 10px">
                        移除
                    </el-link>
                </div>
            </template>
        </myTable>
    </div>
</template>
<script>

const activeOptions = [
    {
        name: "待开始",
        id: 1,
    },
    {
        name: "进行中",
        id: 3,
    },
    {
        name: "已结束",
        id: 4,
    },
    {
        name: "已停止",
        id: 2,
    },
    {
        name: "草稿中",
        id: 0,
    },
];
import myTable from "@/components/myTable";
import { getAllSubsidyGoodsInfo } from "@/api/platSubsidyManage/index.js";
import {  subsidyGoodsDelete } from "@/api/platSubsidyManage";
// 补贴商品列表
export default {
    components: { myTable },
    props: {},
    data() {
        return {
            activeOptions,
            loading: false,
            formSearch: this.initFormSearch(),
            page: {
                total: 0,
                current: 1,
                size: 10,
                pageSizes: [10, 20, 30, 50],
            },
            tableData: [],
            tableOption: [
                { label: "活动名称", prop: "name", },
                { label: "活动状态", prop: "status", slot: true },
                { label: "活动时间", prop: "activeTime", slot: true },
                { label: "店铺名称", prop: "shopName", },
                { label: "商品信息", prop: "platformActivityGoodsInfoVO", slot: true,minWidth: 200 },
                // { label: "补贴价", prop: "subsidyPrice", type: 'money' },
                { label: "补贴方式", prop: "subsidyType", slot: true, minWidth: 150 },
                { label: "已补贴金额", prop: "subsidyPrice", type: 'money' },
                { label: "操作", prop: "operation", slot: true },
            ],
        };
    },
    filters: {
        filtersStatus(e) {
            for (let i = 0; i < activeOptions.length; i++) {
                if (e == activeOptions[i].id) {
                    return activeOptions[i].name;
                }
            }
        },
    },
    created() { },
    mounted() {
        this.getList();
    },
    methods: {
        initFormSearch() {
            return {
                activityName: '', // 活动名称
                shopName: '', // 店铺名称
                goodsInfo: '', // 商品信息
                status: '', // 状态 0-草稿，1-待开始，2-已停止，3-进行中，4-已结束
                date: [], // 活动时间
            }
        },
        search() {
            this.page.current = 1;
            this.getList();
        },
        reset() {
            this.formSearch = this.initFormSearch();
            this.search()
        },
        getList() {
            const { date, ...form } = this.formSearch;
            const { current, size } = this.page;
            let params = {
                ...form,
                current,
                size
            };
            if (date && date.length) {
                const [strTime, endTime] = date;
                params.strTime = strTime;
                params.endTime = endTime;
            }
            this.loading = true
            getAllSubsidyGoodsInfo(params).then((res) => {
                if (res) {
                    this.tableData = res.records || [];
                    this.page.total = res.total || 0;
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 移除商品
        deletGoods(row) {
            this.$confirm(`确定要移除该商品吗?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                if (row.id) {
                    // 删除活动商品
                    subsidyGoodsDelete(row.id).then((res) => {
                        this.$message.success('操作成功！')
                        this.getList()
                    }).catch((err) => { })
                }

            }).catch(() => { });

        },

    },
};
</script>
<style lang="scss" scoped>
.page-content {
    display: flex;
    flex-direction: column;
}

::v-deep.zt__table {
    flex: 1;
    height: 0;

    .el-table {
        height: calc(100% - 29px) !important;
    }
}

::v-deep.el-table .el-table__body-wrapper {
    height: calc(100% - 78px) !important;
    overflow-y: scroll !important;
}

.expand-form {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
}

.header-box {
    .el-form-item {
        margin-bottom: 4px !important;
    }
}

.flex-box {
    display: flex;
    justify-content: space-between;
}

.goods-info {
    min-width: 150px;
    display: flex;
    align-items: flex-start;

    &-image {
        width: 80px;
        height: 80px;
        flex-shrink: 0;
    }

    &-content {
        margin-left: 8px;

        p {
            margin: 0;
            font-size: 12px;
        }

        .goods-name {
            font-weight: 600;
        }
    }
}
.subsidy-type-cls{
    font-size: 13px;
}
</style>
  